<template>
    <div class="warp">
      <div v-if="moduletag === 2 && $route.path !== '/monitor'" style="float:left;width: 30px;height: 30px"><i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" style="font-size: 28px;color: #7ebbfc;" @click="changeOpen"></i></div>
      <div style="float:left;width: calc(100% - 30px);height: 30px">
        <el-tabs
          class="eltabs"
          v-model="activeIndex"
          @tab-click='tabClick'
          @tab-remove='tabRemove'
          :closable="false">
          <el-tab-pane
            :key="item.name"
            v-for="item in openTab"
            :label="item.name"
            :name="item.route"
            :closable="!(openTab.length === 1)">
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
</template>

<script>
export default {
  name: 'navWrap',
  data () {
    return {
      isCollapse: false,
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
  },
  mounted () {
    // 刷新时以当前路由做为tab加入tabs
    // 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
    // 当当前路由是首页时，添加首页到store，并设置激活状态
    // if (this.$route.path !== '/home' && this.$route.path !== '/monitor') {
    //   this.$store.commit('set_active_index', this.$route.path)
    // } else {
    //   this.$store.commit('set_active_index', '/monitor')
    //   this.$router.push('/monitor')
    // }
  },
  computed: {
    openTab () {
      return this.$store.getters.openTab
    },
    activeIndex: {
      get () {
        return this.$store.getters.activeIndex
      },
      set (val) {
        this.$store.commit('set_active_index', val)
      }
    }
  },
  watch: {
    // 监听NavBar导航路由
    '$route' (to, from) {
      // 判断路由是否已经打开
      // 已经打开的 ，将其置为activeIndex
      // 未打开的，将其放入队列里
      // console.log(9876, to)
      let flag = false
      let sendname = to.name
      if (to.path === '/community') {
        if (this.$store.state.user.moduletag === 1) {
          sendname = '小区管理'
        }
      } else if (to.path === '/homeManagement') {
        if (this.$store.state.user.moduletag === 1) {
          sendname = '家庭管理'
        }
      }
      this.$nextTick(() => {
        for (let i = 0; i < this.openTab.length; i++) {
          let item = this.openTab[i]
          if (item.name === sendname) {
            this.$store.commit('set_active_index', to.path)
            flag = true
            break
          }
        }
        if (!flag) {
          flag = false
          // 遍历一级路由，如果是一级路由就进行添加，否则就进行子路由跳转 index.js routes
          for (let i = 0; i < this.$router.options.routes[1].children.length; i++) {
            if (to.name === this.$router.options.routes[1].children[i].name) {
              flag = true
            }
          }
          if (flag) {
            let path = this.$route.path
            let role = this.$store.state.user.role
            let customerservicetag = this.$store.state.user.customerservicetag
            let moduletag = this.$store.state.user.moduletag
            if (!this.routejs.isOpenRoute(path, role, customerservicetag, moduletag)) {
              history.back()
              return
            }
            this.$store.commit('add_tabs', {route: to.path, name: sendname})
            this.$store.commit('set_active_index', to.path)
          }
        }
      })
    }
  },
  methods: {
    // tab标签点击时，切换相应的路由
    tabClick (tab) {
      // console.log(tab)
      this.$router.push({path: this.activeIndex})
      if (this.moduletag === 2) {
        let obj = {
          type: 'path',
          path: this.activeIndex
        }
        this.$emit('changeMenu', obj)
      }
    },
    // 移除tab标签
    tabRemove (targetName) {
      // 首页不删
      if (targetName === '/PoliceCenter') {
        return
      }
      if (targetName === '/MonitoringCenter' && this.$store.state.user.role === 'data') {
        return
      } else if (targetName === '/UserManage' &&
        (this.$store.state.user.role === 'user_create' || this.$store.state.user.role === 'user_approve' || this.$store.state.user.role === 'user_log')) {
        return
      }
      this.$store.commit('delete_tabs', targetName)
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTab && this.openTab.length >= 1) {
          this.$store.commit('set_active_index', this.openTab[this.openTab.length - 1].route)
          this.$router.push({path: this.activeIndex})
        } else {
          this.$router.push({path: '/PoliceCenter'})
        }
      }
    },
    changeOpen () {
      this.isCollapse = !this.isCollapse
      let obj = {
        type: 'isCollapse'
      }
      this.$emit('changeMenu', obj)
    }
  }
}
</script>

<style scoped>
.warp{
  width: 100%;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/childNavBar/navWrap.vue